import print from 'print-js';
import moment from 'moment';

import { initGrid } from 'utils/grid/grid';

import { onItemListSelection } from 'manage-inventory/actions/manage-inventory.actions';
import { downloadManageInventoryReportByTab } from 'manage-inventory/actions/download-report-by-tab.actions';
import { fetchOrderHistoryList } from 'manage-inventory/actions/fetch-order-history-list.actions';

import template from './inventory-order-history-independet-tab.html';

const mapStateToThis = ({ dictionary, session, ui, config, manageInventory }) => {
  const { defaultPageSizes, sortColumnKey, pageSizeKey, directionKey, defaultPageNo } = config;
  const { orderHistoryLoadingStatus, orderHistory } = manageInventory;
  const { locale, salesPeriodTimestamp } = session;
  const { activeTab, pagination } = ui;

  const terms = dictionary.terms[locale];

  return {
    terms,
    locale,
    activeTab,
    pagination,
    pageSizeKey,
    orderHistory,
    directionKey,
    defaultPageNo,
    sortColumnKey,
    defaultPageSizes,
    salesPeriodTimestamp,
    orderHistoryLoadingStatus,
  };
};

const mapDispatchToThis = {
  onItemListSelection,
  fetchOrderHistoryList,
  downloadManageInventoryReportByTab,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Notifications', 'tableService', 'manageInventoryTableService', '$stateParams')
class InventoryOrderHistoryIndependentTabController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.print = print;
  }

  $onInit() {
    this.actions = this.getActions();
    this.toDate = moment.unix(this.salesPeriodTimestamp).endOf('month').format('YYYY-MM-DD');

    this.tableConfig = this.tableService.initConfig({ configName: 'orderHistoryIndependent' });
    this.headers = this.tableConfig.getHeaders(this.manageInventoryTableService.getHeaders());

    this.defaultParams = {
      [this.pageSizeKey]: this.defaultPageSizes[2],
      [this.sortColumnKey]: 'orderIssuedDate',
      [this.directionKey]: false,
      retailerId: this.$stateParams.retailerNo,
    };

    this.gridModel = initGrid(this.fetchOrderHistoryList, this.defaultParams);

    this.gridModel.pagingModel.filters = {
      ...this.gridModel.pagingModel.filters,
      refresh: true,
      toDate: this.toDate,
      locale: this.locale,
    };

    this.preserveFilters();
    this.search();
  }

  $onDestroy() {
    this.unsubscribe();
  }

  preserveFilters() {
    this.preservedFilters = { ...this.gridModel.pagingModel.filters };
  }

  getActions() {
    return [
      {
        type: 'download',
        function: this.onDownloadReport.bind(this),
        extension: 'xlsx',
      },
      {
        type: 'print',
        function: this.handlePrint.bind(this),
      },
    ];
  }

  search() {
    this.gridModel.applyFilters().then(() => {
      this.preserveFilters();
    });
  }

  clear() {
    this.gridModel.pagingModel.filters = { monthNumber: this.monthNumber };
    this.search();
  }

  orderDetails(order) {
    const { retailerId } = this.gridModel.pagingModel.filters;
    const retailerNumber = this.selectedRetailerId;
    this.onItemListSelection({ ...order, retailerId, retailerNumber });

    this.Notifications.showComplexDialog({
      component: 'detailsDialog',
      resolve: {
        hidePackDetails: true,
      },
    });
  }

  onDownloadReport() {
    const params = {
      ...this.gridModel.pagingModel,
      tabId: this.activeTab,
      filters: this.preservedFilters,
      pageSize: 0, // BE contract - pageSize = 0 triggers exporting entire data set
    };

    return this.downloadManageInventoryReportByTab(params);
  }

  handlePrint() {
    this.print({
      printable: 'inventory-order-history-independet-tab',
      type: 'html',
    });
  }
}

export default class InventoryOrderHistoryIndependentTabComponent {
  constructor() {
    this.controller = InventoryOrderHistoryIndependentTabController;
    this.template = template;
  }
}



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-order-history-independet-tab/inventory-order-history-independet-tab-component.js